export function splitStreamTail(text, tailLength = 12) {
  const value = String(text ?? '')
  if (!value || tailLength <= 0) return { settled: value, tail: '' }
  if (value.length <= tailLength) return { settled: '', tail: value }
  return {
    settled: value.slice(0, value.length - tailLength),
    tail: value.slice(value.length - tailLength),
  }
}
